import { Layout } from "antd";
import { Navigate } from "react-router";

import BaseHeader from "@/components/Header/BaseHeader";
import HeaderButtons from "@/components/Header/Intervention/HeaderButtons";
import RecommendedBy from "@/components/Intervention/RecommendedBy";
import WithoutTemplate from "@/components/Intervention/WithoutTemplate";
import { useGetAsset } from "@/entities/asset";
import {
  INTERVENTION_INCLUDES,
  useGetIntervention,
} from "@/entities/intervention";
import InterventionEdit from "@/features/Interventions/InterventionEdit";
import InterventionBreadcrumb from "@/modules/intervention/intervention-breadcrumb";
import { InterventionIndicator } from "@/modules/intervention/intervention-indicator";
import InterventionSectionSaveBar from "@/modules/intervention/intervention-section-save-bar";
import { useSidePanel } from "@/modules/side-panel";
import { isError404 } from "@/services/api";
import { useIdParam } from "@/services/router";

import InterventionContext from "./InterventionContext";
import InterventionDetailsTabs from "./InterventionDetailsTabs";

const { Content } = Layout;

const Details = () => {
  const id = useIdParam();
  const { openSidePanel } = useSidePanel();

  const InterventionIncludes = [
    INTERVENTION_INCLUDES.USERS,
    INTERVENTION_INCLUDES.PROJECT,
    INTERVENTION_INCLUDES.FOLLOWUP,
  ].join(",");

  const {
    isLoading: isInterventionLoading,
    intervention,
    error,
  } = useGetIntervention(id, {
    params: {
      include: InterventionIncludes,
    },
  });

  const { isLoading: isAssetLoading, asset } = useGetAsset(
    intervention?.asset_id
  );

  const isLoading = isInterventionLoading || isAssetLoading;

  const onAddTemplateClick = () => {
    openSidePanel({
      title: intervention?.name,
      component: <InterventionEdit interventionId={intervention?.id} />,
    });
  };

  const extras = isLoading ? null : (
    <HeaderButtons key="HeaderButtons" intervention={intervention} />
  );

  if (!id || isError404(error)) {
    return <Navigate to="/interventions" replace />;
  }

  return (
    <InterventionContext.Provider value={intervention}>
      <div className="intervention-details-wrapper">
        <BaseHeader
          title={intervention?.name}
          afterTitle={
            <InterventionIndicator intervention={intervention} isBig />
          }
          breadcrumb={
            <>
              <InterventionBreadcrumb intervention={intervention} />
              <RecommendedBy
                recommendedBy={intervention?.recommended_by}
                loading={isLoading}
              />
            </>
          }
          loading={isLoading}
          extra={[extras]}
          wrapExtra={300}
        />
        {intervention?.intervention_template_id ? (
          <>
            <InterventionSectionSaveBar
              loading={isLoading}
              intervention={intervention}
              screenSize="small"
            />
            <Content>
              <InterventionDetailsTabs
                intervention={intervention}
                interventionAsset={asset}
                loading={isLoading}
              />
            </Content>
          </>
        ) : (
          <WithoutTemplate
            loading={isLoading}
            onButtonClick={onAddTemplateClick}
          />
        )}
      </div>
    </InterventionContext.Provider>
  );
};

export default Details;
